var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Congo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M24,4C12.954,4,4,12.954,4,24c0,3.111,0.731,6.043,1.998,8.669L32.669,5.998 C30.043,4.731,27.111,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24c0-3.111-0.731-6.043-1.998-8.669L15.331,42.002C17.957,43.269,20.889,44,24,44 C35.046,44,44,35.046,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M32.669,5.998L5.998,32.669c1.965,4.072,5.261,7.368,9.333,9.333l26.671-26.671 C40.037,11.259,36.741,7.963,32.669,5.998z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Congo);
export default __webpack_public_path__ + "static/media/icons8-congo.fbcde84b6a0858472be8719d0dc184c1.svg";
export { ForwardRef as ReactComponent };